<template>
  <div>
    <div v-if="cartorioObj.frente_caixa"
         class="content--sinoreg">
      <header class="headerBlue">
        <h4 class="resumo-show_title pl-2 mt-3">
          <span class="pt-3 resumo-show_title-label">
            Frente de Caixa
          </span>
        </h4>
      </header>
      <b-tabs content-class=""
              class="Resumo-border mt-3 position-relative"
              align="left"
              active-nav-item-class="Resumo--tab-active">
        <b-tab @click="mudarStatusPedido('pendente')">
          <template v-slot:title>
            <span>Pendente</span>
          </template>
        </b-tab>

        <b-tab @click="mudarStatusPedido('concluido')">
          <template v-slot:title>
            <span>Concluídos</span> 
          </template>
        </b-tab>
        <FiltragemPorData class="w-50 position-absolute filtro" />
      </b-tabs>
      <frente-de-caixa-pendetes v-if="status == 'pendente'" /> 
      <FrenteDeCaixaConcluidos v-else /> 
    </div>
    <div v-else>
      {{ handlerCaixaDesativado() }}
    </div>
  </div>
</template>

<script>
  // Componentes
  import FrenteDeCaixaPendetes from './FrenteDeCaixaPendentes/FrenteDeCaixaPendentes.vue'
  import FrenteDeCaixaConcluidos from "./FrenteDeCaixaConcluidos/FrenteDeCaixaConcluidos"
  import FiltragemPorData from "./FrenteDeCaixaConcluidos/FiltragemPorData/FiltragemPorData"

  // Services
  import pedidoService from "./pedidoService"
  import CaixaService from './caixaService'
  import caixaService from './caixaService'



  export default {
    name: "FrenteDeCaixa",
    components: {
      FrenteDeCaixaConcluidos,
      FrenteDeCaixaPendetes,
      FiltragemPorData,
    },
    props: {

    },
    data () {
      return {
        dataFinanceiro: {
          pedidos: null,
          formaPg: null,
          tipoPg: null,
          pagamentosAvulso: null,
        },
        cartorioObj: null
      }
    },
    computed: {
      status () {
        return this.$store.state.frenteCaixa.status
      },
      cxData () {
        return this.$store.state.frenteCaixa.cxData
      },
      cxPedidos () {
        return this.$store.state.frenteCaixa.pedidos
      },
      caixa () {
        return this.$store.state.frenteCaixa.caixa
      },
      filtroPedidos () {
        return this.$store.state.frenteCaixa.filtro
      },
      handlerCaixaDesativado () {
        return displayMessage('error', 'Frente de Caixa desativado', 'Para ativar e começar a usar o modulo Frente de Caixa acesse no menu lateral => Cadastro serventia e clique no módulo para ativa-lo.') 
      }

    },
    watch: {
      async 'cxData' () {
        await this.getCaixaDia()
      },
    },
    async created () {
      await this.getCaixaDia()
      this.$store.dispatch('frenteCaixa/atualizarStatus', 'pendente')
      this.cartorioObj = this.$store.state.auth.cartorioObj
    },
    methods: {
      mudarStatusPedido (event) {
        this.$store.dispatch('frenteCaixa/atualizarStatus', event)
      },
      async getCaixaDia () {
        try {
          const caixa = await CaixaService.caixaAtual(this.cxData) || null
          if (!caixa) {
            let caixaAnterior = await caixaService.caixaAnterior()
            caixaAnterior.ultimoCaixa = true
            this.$store.dispatch('frenteCaixa/atualizarCaixa', caixaAnterior)
          } else {
            this.$store.dispatch('frenteCaixa/atualizarCaixa', caixa)
          }
        } catch (error) {

        }
      }
    }
  }

</script>

<style lang="scss" scoped>
  @import "../../../scss/_utilities/_variables";
  .headerBlue{
    background-color: $sinoreg-blue;
    color: $color-white;
    fill: $color-white;
    padding: pxToRem(8);
    font-size: pxToRem(20);
    font-weight: 500;
    height: 100%;
    width: 100%;
  }
  .filtro {
    bottom:10px;
    right:0;
  }
  .content-caixa {
    width: 70%;
    margin: 0 auto;
    margin-top: 10%;
    padding: 14px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  }
</style>